/* eslint-disable max-len */

if (process.env.BROWSER) {
  // throw new Error('Do not import `config.js` from inside the client-side code.');
  console.warn('`config.js` accessed from inside the client-side code.');
}
// method to configure refresh_token cookie variable name according to the instance
const refreshTokenCookieName = () => {
  let name = 'refresh_token';
  const sagRoot = process.env.SAG_ROOT;
  if (sagRoot.includes('dabba')) {
    name = `${name}_development`;
  } else if (sagRoot.includes('test')) {
    name = `${name}_testing`;
  }
  return name;
}
module.exports = {
  // Node.js app
  port: process.env.PORT || 3000,

  // API Gateway
  api: {
    // API URL to be used in the client-side code
    clientUrl: process.env.API_CLIENT_URL || '',
    // API URL to be used in the server-side code
    serverUrl:
      process.env.API_SERVER_URL ||
      `http://${process.env.COOKIE_DOMAIN}:${process.env.PORT || 3000}`,
  },

  // Database
  databaseUrl: process.env.DATABASE_URL || 'sqlite:database.sqlite',

  // API ROOT
  API_ROOT: process.env.API_ROOT || 'http://localhost:8200/',
  SAG_ROOT: process.env.SAG_ROOT || 'https://sag.test.spotmentor.com/',

  // Client details
  CLIENT_ID: process.env.CLIENT_ID,
  CLIENT_SECRET: process.env.CLIENT_SECRET,
  SAG_CLIENT_ID: process.env.SAG_CLIENT_ID || '5bd4431afcc4f50025e25e51',
  SAG_CLIENT_SECRET: process.env.SAG_CLIENT_SECRET || 'ebe4c92c6397f36800a315592a1d544b670e1d00',
  SPOTMENTOR_ENV: process.env.SPOTMENTOR_ENV === 'testing' || process.env.SPOTMENTOR_ENV === 'development' ? `refresh_token_${process.env.SPOTMENTOR_ENV}` : 'refresh_token',

  // Cookies
  COOKIE_DOMAIN: process.env.COOKIE_DOMAIN || 'localhost.dabba.spotmentor.com',
  COOKIE_TIMEOUT: process.env.COOKIE_TIMEOUT || (30 * 24 * 3600),
  REFRESH_COOKIE_TIMEOUT: process.env.COOKIE_TIMEOUT || (10 * 365 * 24 * 3600),

  // Timeouts
  POLL_TIMEOUT: process.env.POLL_TIMEOUT || (30 * 1000),

  // Spotmentor package id
  PACKAGE_ID: process.env.PACKAGE_ID,

  // Colors
  BRAND_COLOR: '#273992',

  // Web analytics
  analytics: {
    // https://analytics.google.com/
    googleTrackingId: process.env.GOOGLE_TRACKING_ID, // UA-XXXXX-X
    gtmContainerId:  process.env.GOOGLE_TAGS_CONTAINER_ID, // GTM-XXXXXXX
  },

  // Authentication
  auth: {
    jwt: { secret: process.env.JWT_SECRET || 'React Starter Kit' },

    // https://developers.facebook.com/
    facebook: {
      id: process.env.FACEBOOK_APP_ID || '186244551745631',
      secret:
        process.env.FACEBOOK_APP_SECRET || 'a970ae3240ab4b9b8aae0f9f0661c6fc',
    },

    // https://cloud.google.com/console/project
    google: {
      id:
        process.env.GOOGLE_CLIENT_ID ||
        '251410730550-ahcg0ou5mgfhl8hlui1urru7jn5s12km.apps.googleusercontent.com',
      secret: process.env.GOOGLE_CLIENT_SECRET || 'Y8yR9yZAhm9jQ8FKAL8QIEcd',
    },

    // https://apps.twitter.com/
    twitter: {
      key: process.env.TWITTER_CONSUMER_KEY || 'Ie20AZvLJI2lQD5Dsgxgjauns',
      secret:
        process.env.TWITTER_CONSUMER_SECRET ||
        'KTZ6cxoKnEakQCeSpZlaUCJWGAlTEBJj0y2EMkUBujA7zWSvaQ',
    },
  },
};



// WEBPACK FOOTER //
// ./src/config.js